import {
  graphHomeImage,
  aboutUs, 
} from '../../../../../images/index.js'

export const empoweringGrowthData = {
  "/about-us": {
    image: aboutUs,
    title: "Empowering Marketplace Growth",
    description:
      "Join thousands of sellers who trust us to power their marketplace business.",
    stats: [
      {
        label: "Total Customers",
        value: "20.345",
        trend: "⬆ 37.8%",
        trendClass: "text-success",
        positionClass: "top-0 start-0",
      },
      {
        label: "Active Customers",
        value: "10.345",
        trend: "⬇ 2%",
        trendClass: "text-danger",
        positionClass: "bottom-0 start-50",
      },
    ],
    features: [
      {
        badge: "1",
        title: "Secure & Reliable",
        description:
          "Use of “industry-grade encryption” and “secure cloud storage” builds trust.",
      },
      {
        badge: "2",
        title: "Fast Integration",
        description:
          "Connect your business with just a few clicks — whether it’s Amazon, or others.",
      },
      {
        badge: "3",
        title: "Mobile Friendly",
        description:
          "Manage your business on the go — our dashboard works flawlessly across all devices.",
      },
      {
        badge: "4",
        title: "Smart Analytics",
        description:
          "Get intelligent insights that go beyond just numbers. Understand trends, tracks profits, and make informed decisions in real time",
      },
    ],
  },
  "/": {
    image: graphHomeImage,
    title: "WHY CHOOSE US",
    heading:"Why Users Trust Our Platform",
    description:
      "We address real business challenges with reliable, easy-to-use tools that deliver results.",
    stats: [],  // add empty array if no stats data
    features: [
      {
        badge: "1",
        title: "Secure & Reliable",
        description:
          "Industry-grade encryption and secure cloud storage ensure data safety and trust.",
      },
      {
        badge: "2",
        title: "Fast Integration",
        description:
          "Connect your business in just a few clicks - whether on Amazon, or other platforms.",
      },
      {
        badge: "3",
        title: "Mobile Friendly",
        description:
          "Manage operations anytime, anywhere - our Dashboard works seamlessly across all devices.",
      },
      {
        badge: "4",
        title: "Smart Analytics",
        description:
          "Access intelligent insights that go beyond numbers. Identify trends, track profits, and make data-driven decisions.",
      },
    ],
  },
  
  // "/": {
  //   image: graphHomeImage,
  //   title: "WHY CHOOSE US",
  //   heading:"Why Most Amazon Sellers Never Break Through To 7-Figure Success",
  //   description:
  //     "These roadblocks keep talented sellers stuck in mediocrity.",
  //   stats: [],  // add empty array if no stats data
  //   features: [
  //     {
  //       badge: "1",
  //       title: "Secure & Reliable",
  //       description:
  //         "Amazon's native reports are confusing and time-consuming Wasted hours with little insight gained",
  //     },
  //     {
  //       badge: "2",
  //       title: "Fast Integration",
  //       description:
  //         "Critical insights are buried in hundreds of data points. Missing opportunities and threats.",
  //     },
  //     {
  //       badge: "3",
  //       title: "Mobile Friendly",
  //       description:
  //         "No clear connection between actions and results Unable to replicate success or avoid failures.",
  //     },
  //     {
  //       badge: "4",
  //       title: "Smart Analytics",
  //       description:
  //         "Access intelligent insights that go beyond numbers. Identify trends, track profits, and make data-driven decisions.",
  //     },
  //   ],
  // },
};
